// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect from "../Effect/index.js";
import * as Restaumatic_Site_I18n from "../Restaumatic.Site.I18n/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var saveOrderPath = /* #__PURE__ */ Restaumatic_Site_I18n.localizeRoute("zamowienie/zapisz");
var reservationPath = /* #__PURE__ */ Restaumatic_Site_I18n.localizeRoute("rezerwuj-stolik");
var paymentChannelsPath = function (v) {
    return pure("/payments/channels" + ("?restaurant_id=" + show(v)));
};
var checkoutPath = /* #__PURE__ */ Restaumatic_Site_I18n.localizeRoute("zamowienie/koszyk");
var checkoutPathWithRestaurantId = function (v) {
    return function __do() {
        var p = checkoutPath();
        return p + ("/" + show(v));
    };
};
var checkCouponPath = /* #__PURE__ */ Restaumatic_Site_I18n.localizeRoute("promocje/sprawdz_kupon");
export {
    saveOrderPath,
    checkoutPath,
    checkoutPathWithRestaurantId,
    checkCouponPath,
    paymentChannelsPath,
    reservationPath
};
